import { z } from "zod";
import { EventStatusSchema } from "./event";

/**
 * Builder 4 — availability + holds + calendar/ICS feed. Mirrors
 * app/api/v2/calendar.py's CalendarEventOut/CalendarHoldOut/
 * CalendarMonthResponse/FeedUrlResponse shapes.
 */

export const CalendarEventSchema = z.object({
  id: z.string(),
  quote_id: z.string(),
  event_date: z.string(),
  status: EventStatusSchema,
  venue_name: z.string().nullable(),
  guest_count: z.number().nullable(),
});
export type CalendarEvent = z.infer<typeof CalendarEventSchema>;

export const CalendarHoldSchema = z.object({
  id: z.string(),
  quote_id: z.string(),
  event_date: z.string(),
  expires_at: z.string(),
});
export type CalendarHold = z.infer<typeof CalendarHoldSchema>;

export const CalendarMonthResponseSchema = z.object({
  year: z.number(),
  month: z.number(),
  events: z.array(CalendarEventSchema),
  holds: z.array(CalendarHoldSchema),
});
export type CalendarMonthResponse = z.infer<typeof CalendarMonthResponseSchema>;

export const FeedUrlResponseSchema = z.object({
  url: z.string(),
});
export type FeedUrlResponse = z.infer<typeof FeedUrlResponseSchema>;
